import { Trans, useLingui } from '@lingui/react/macro';

import InputText from '@/design_system/InputText';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';

export const TrackingNumberInput = ({
  trackingNumber,
  setTrackingNumber,
}: {
  trackingNumber: string | undefined;
  setTrackingNumber: (trackingNumber: string | undefined) => void;
}) => {
  const { t } = useLingui();

  return (
    <InputText
      label={
        <>
          <Trans id="article.actions.processing.confirm.tracking-number.label">
            Tracking number
          </Trans>
          <OptionalLabel />
        </>
      }
      aria-label={t({
        id: 'article.actions.processing.confirm.tracking-number.label',
        message: 'Tracking number',
      })}
      placeholder={t({
        id: 'article.actions.processing.confirm.tracking-number.placeholder',
        message: 'Add the carrier tracking number',
      })}
      value={trackingNumber}
      onChange={(value) => setTrackingNumber(value)}
    />
  );
};
